import { Component, inject, input } from '@angular/core';
import { MatListModule } from "@angular/material/list";
import { MatIconModule } from "@angular/material/icon";
import { TranslatePipe } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { IAuditBaseModel } from '../../../../features/audit-trail/models/audit-base-model.model';
import { Router } from '@angular/router';
import { MatAnchor } from "@angular/material/button";

@Component({
  selector: 'app-audit-trail',
  imports: [
    MatListModule,
    MatIconModule,
    TranslatePipe,
    DatePipe,
    MatAnchor,
  ],
  templateUrl: './audit-trail.html',
  styleUrl: './audit-trail.scss'
})
export default class AuditTrail {
  public readonly autitTrail = input.required<IAuditBaseModel>();
  private readonly fouter = inject(Router);


  showHistory() {
    this.fouter.navigate([`/audit-trail/${this.autitTrail().entity}/${this.autitTrail().id}`]);
  }

}
